<template>
    <div>
        <label class="v-label theme--light">{{label}}</label>
        <v-list :key="renderKey">
            <draggable v-model="componentlist" @change="$emit('input', componentlist)" tag="ContentsContainer">
                <v-list-item v-for="(item,itemindex) in componentlist" :key="item.id">
                    <v-row no-gutters>
                        <v-col cols=10 @click="setSelectedEditComponent(item)" class="black--text">
                            <div v-if="item.component" style="line-height: 40px">
                                <v-icon class="mr-1">{{getIcon(item)}}</v-icon>
                                {{$translate(getTitle(item))}}
                            </div>
                            <div v-else>{{$translate('No component')}}</div>
                        </v-col>
                        <v-col cols=2>
                            <v-btn
                                @click="removeItem(componentlist, itemindex)"
                                color="error"
                                fab
                                small
                                style="margin-left: 8px"
                            >
                                <v-icon>mdi-delete</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-list-item>
            </draggable>
        </v-list>

        <v-btn
            @click="addItem(componentlist, prop)"
            color="zoezi-edit-color"
            fab
            small
            class="mb-2"
            v-if="!prop.typeinfo || !prop.typeinfo.max || prop.typeinfo.max > componentlist.length"
        >
            <v-icon>mdi-plus</v-icon>
        </v-btn>
    </div>
</template>


<script>
import components from '../component.js';
import Draggable from 'vuedraggable';
export default {
    name: 'ComponentListSetting',

    components: {
        Draggable
    },

    props: ['value', 'label', 'component', 'prop'],
    data: () => ({
        renderKey: 0,
        componentlist: null
    }),
    methods: {
        removeItem(item, itemindex) {
            item.splice(itemindex, 1);
            this.$emit('input', this.componentlist);
            ++this.renderKey;
        },
        addItem(items) {
            let newitem = {};
            if (this.prop.typeinfo && this.prop.typeinfo.component) {
                newitem.component = this.prop.typeinfo.component;
            }
            if (this.prop.typeinfo && this.prop.typeinfo.setNewConfig) {
                this.prop.typeinfo.setNewConfig(newitem, this.component);
            }

            items.splice(items.length, 0, components.makeEmptyConfig(newitem));
            this.setSelectedEditComponent(items[items.length-1]);
            this.$emit('input', this.componentlist);
            ++this.renderKey;
        },
        componentInfo(name) {
            return components.getComponent(name);
        },
        setSelectedEditComponent(config) {
            this.$store.dispatch('setEditComponentConfig', {config, parentComponent: this.component})
        },
        getTitle(item) {
            if (item.props.title) {
                return item.props.title
            }
            return this.componentInfo(item.component).zoezi.title;
        },
        getIcon(item) {
            if (item.props.icon) {
                return item.props.icon
            }
            return this.componentInfo(item.component).zoezi.icon;
        }
    },
    created() {
        this.componentlist = this.value;
    }
}
</script>
